module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9554_azure.7da3ff63.jpg";